import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TextEllipsisResizeObserverService {
  private readonly callbacks = new Map<Element, () => void>();
  private readonly resizeObserver = new ResizeObserver((entries) => entries.forEach((entry) => this.callbacks.get(entry.target)?.()));

  public observe(element: Element, callback: () => void): void {
    this.callbacks.set(element, callback);
    this.resizeObserver.observe(element);
  }

  public unobserve(element: Element): void {
    this.callbacks.delete(element);
    this.resizeObserver.unobserve(element);
  }
}
